import { render, staticRenderFns } from "./BannerEmployersHire.vue?vue&type=template&id=19bddb7b&scoped=true&"
import script from "./BannerEmployersHire.vue?vue&type=script&lang=js&"
export * from "./BannerEmployersHire.vue?vue&type=script&lang=js&"
import style0 from "./BannerEmployersHire.vue?vue&type=style&index=0&id=19bddb7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bddb7b",
  null
  
)

export default component.exports